import React, { useEffect, useState } from 'react';
import { apiUrl } from '../lib/config';

type Props = { children: React.ReactNode };
type PublicSettings = {
    shopOpen?: boolean;
    shopClosedMessage?: string;
};

const ShopStatusGate: React.FC<Props> = ({ children }) => {
    const [state, setState] = useState<'loading' | 'open' | 'closed'>('loading');
    const [message, setMessage] = useState<string>('');

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const resp = await fetch(apiUrl('/api/settings/public'));
                const data = (await resp.json()) as PublicSettings;
                if (cancelled) return;
                if (data.shopOpen === false) {
                    setMessage(data.shopClosedMessage ?? '🔒 Siamo chiusi al momento. Torna presto!');
                    setState('closed');
                } else {
                    setState('open');
                }
            } catch {
                if (!cancelled) setState('open');
            }
        })();
        return () => { cancelled = true; };
    }, []);

    if (state === 'loading') return <>{children}</>;
    if (state === 'open') return <>{children}</>;

    return (
        <div className="shop-closed">
            <div className="shop-closed-card">
                <div className="shop-closed-icon" aria-hidden="true">🔒</div>
                <h2>Negozio chiuso</h2>
                <p className="shop-closed-message">{message}</p>
            </div>
        </div>
    );
};

export default ShopStatusGate;
